import { useReduxState } from 'hooks';
import { PreEditor } from 'components/editor/inputs';
import { EditorBlockEmbedPreview } from '.';

import type { BlockEmbed } from 'shared-types';
import type {
  BlockProps,
  EditorStateProps
} from 'components/editor/blocks/EditorBlock';

export type BlockEmbedStateProps = Pick<
  EditorStateProps,
  'editorLanguageActive' | 'editorLanguageReference'
>;

const EditorBlockEmbed = ({
  blockId,
  data,
  isPreview,
  languageVersion,
  updateData,
  ...stateProps
}: BlockProps<BlockEmbed> & BlockEmbedStateProps) => {
  const { editorLanguageActive, editorLanguageReference } = stateProps;

  const { messages, theme } = useReduxState();

  const handleChange = (newContent: string) => {
    updateData({
      ...data,
      locales: {
        ...data.locales,
        [languageVersion]: {
          ...data.locales[languageVersion],
          text: newContent,
          translatable: {
            ...data.locales[languageVersion].translatable
          }
        }
      }
    });
  };

  return (
    <div className="embed">
      <PreEditor
        isPreview={isPreview}
        onChange={handleChange}
        placeholder={messages.commonAddText}
        style={{ backgroundColor: theme.lightGreyDark }}
        text={data.locales[languageVersion].text || ''}
        translationReferenceBackgroundColor={theme.lightGreyDark}
        translationReferenceLanguage={editorLanguageReference}
        translationReferenceText={
          editorLanguageActive
            ? data.locales[editorLanguageReference]?.text || ''
            : null
        }
        title={messages.blocksEmbedCode}
      />

      <EditorBlockEmbedPreview
        blockId={blockId}
        blockType="embedcode"
        data={data}
        isPreview={isPreview}
        languageVersion={languageVersion}
        loading={false}
        style={{ marginTop: 20 }}
        updateData={updateData}
        updateOnChange={data.locales[languageVersion].text}
        {...stateProps}
      />

      <style jsx>{`
        .embed {
          background-color: ${theme.lightGrey};
          border-radius: ${theme.cardBorderRadius};
          padding: 15px;
        }
      `}</style>
    </div>
  );
};

export default EditorBlockEmbed;
